import { useAuth } from "../../contexts/useAuth";
import ErrorPage from "../../pages/ErrorPage";

const ProtectedRoute = ({
  children,
  requireSalon = false,
  requireEmployee = false,
}) => {
  const { session, currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div
        className="pr-fullscreen"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "linear-gradient(135deg, #dde4f5 0%, #e8e4f5 40%, #d8dff0 100%)",
        }}
      >
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            border: "3px solid rgba(179,157,219,0.2)",
            borderTopColor: "#b39ddb",
            animation: "pr-spin 0.8s linear infinite",
          }}
        />
        <style>{`
          .pr-fullscreen { min-height: 100vh; min-height: 100dvh; }
          @keyframes pr-spin { to { transform: rotate(360deg); } }
        `}</style>
      </div>
    );
  }

 // Require authentication
  if (!session) return <ErrorPage />;

  // Session exists but profile fetch failed (5xx) — don't render children with null user
  if (!currentUser && !loading) return <ErrorPage />;

  // Specific role requirements (only used for admin routes, etc.)
  if (requireSalon && currentUser?.role !== "salon") {
    return <ErrorPage />;
  }

  // Allow all authenticated users to access frontend
  // No longer block salon/employee roles from frontend access
  // Platform separation is enforced by mobile app restrictions

  if (requireEmployee && currentUser?.role !== "employee") {
    return <ErrorPage />;
  }

  return children;
};

export default ProtectedRoute;